import { type JSX, splitProps } from 'solid-js'
import { Dynamic } from 'solid-js/web'
import './Card.css'

export type CardVariant = 'default' | 'outlined' | 'soft'
export type CardPadding = boolean | 'sm' | 'md' | 'lg' | 'xl'

interface CardOwnProps {
  interactive?: boolean | undefined
  hoverable?: boolean | undefined
  selected?: boolean | undefined
  elevated?: boolean | undefined
  variant?: CardVariant | undefined
  radius?: 'lg' | 'xl' | undefined
  padded?: CardPadding | undefined
}

export type CardProps = CardOwnProps &
  (
    | ({ as?: 'div' | undefined } & JSX.HTMLAttributes<HTMLDivElement>)
    | ({ as: 'button' } & JSX.ButtonHTMLAttributes<HTMLButtonElement>)
  )

export function Card(props: CardProps) {
  const [local, rest] = splitProps(props, [
    'as',
    'interactive',
    'hoverable',
    'selected',
    'elevated',
    'variant',
    'radius',
    'padded',
    'class',
    'children',
  ])
  const isButton = () => local.as === 'button'
  const padded = () => (local.padded === undefined ? true : local.padded)
  const classes = () =>
    [
      'ds-card',
      local.radius === 'xl' && 'ds-card--xl',
      local.variant === 'outlined' && 'ds-card--outlined',
      local.variant === 'soft' && 'ds-card--soft',
      local.elevated && 'ds-card--elevated',
      padded() === true && 'ds-card--pad',
      padded() === 'sm' && 'ds-card--pad-sm',
      padded() === 'md' && 'ds-card--pad-md',
      padded() === 'lg' && 'ds-card--pad-lg',
      padded() === 'xl' && 'ds-card--pad-xl',
      (local.interactive || isButton()) && 'ds-card--interactive',
      local.hoverable && 'ds-card--hoverable',
      local.selected && 'ds-card--selected',
      isButton() && 'ds-card--button',
      local.class,
    ]
      .filter(Boolean)
      .join(' ')

  return (
    <Dynamic
      component={isButton() ? 'button' : 'div'}
      type={isButton() ? 'button' : undefined}
      data-selected={local.selected ? '' : undefined}
      {...rest}
      class={classes()}
    >
      {local.children}
    </Dynamic>
  )
}
